//const baseurl = "http://192.168.168.57:8080/breakdowninc/";
const baseurl = "https://api.breakdowninc.net/";

const BaseUrl={
    baseurl
};

export default BaseUrl;